import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Common from "../../layouts/Common";
import Breadcrumb from "react-bootstrap/Breadcrumb";
// import grap from "../../assets/images/grap.jpeg";
// import digital from "../../assets/images/digital.jpeg";
import { NavLink } from "react-router-dom";
import "./training.css";

const Training = () => {
  return (
    <Common>
      <section className="sub-page-banner pa-sub  tra-bg">
        <Container>
          <Row>
            <Col md={12} className="text-center sup-page-inner">
              <h2>Training</h2>
              <Breadcrumb className="text-center custom-breadcrumb">
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item>Training</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
          </Row>
        </Container>
      </section>
      <Container className="training-container">
        <Row className="text-center ms-0">
          <Col md={12} className="hoverer">
            <div className="full-container">
              <div className="img-container">
                {/* <img src={grap} alt="courses" /> */}
                <div className="details-holder">
                {/* <div className="heading">কোর্স ডেসক্রিপশন </div> */}
                <div>
                  ASSET প্রকল্পের আওতায় NSDA অনুমোদিত বিশ্ব ব্যাংকের অর্থায়নে পরিচালিত প্রশিক্ষণ কর্মশালার অংশগ্রহণ করে ক্যারিয়ার গড়ুন!

                </div>
                <div className="heading mt-3">
                  কোর্সের নামঃ
                </div>
                <ul>
                  <li>গ্রাফিক্স ডিজাইন ফর ফ্রিল্যান্সিং (লেভেল-৩)</li>
                  {/* <li> ডিজিটাল মার্কেটিং ফর ফ্রিল্যান্সিং (লেভেল-৩)</li> */}
                  
                </ul>
                {/* <div className="heading">ক্লাস শুরু : ১৫/১১/২০২৫</div> */}
                <div className="heading mt-3">সময়কালঃ <span className="text-black">৩ মাস</span></div>
                 <div className="heading mt-1">সপ্তাহে ক্লাসঃ <span  className="text-black">৫/৬ দিন</span></div>
                  <div className="heading mt-1">প্রতিদিন ক্লাস সময়ঃ <span  className="text-black">৪ ঘন্টা</span></div>
                {/* <ul>
                  <li>নূন্যতম এইচ.এস.সি পাস</li>
                  <li>বয়স সর্বনিম্ন ১৮ হইতে সর্বোচ্চ ৪০ (পুরুষ ও মহিলা)</li>
                </ul> */}


                <div className="mt-3">
                  <p className="w-full mb-0 heading"><strong>প্রশিক্ষণ লোকেশনঃ</strong></p> EATL, Corporate Office: Rupayan Shopping Square, Level-6, Plot-2, Block-G, Sayem Sobhan Anvir Road, Bashundhara R/A, Dhaka-1229, Bangladesh.

                </div>
                <div className="heading mt-3">সুযোগ-সুবিধাঃ</div>
                  <ol className="mt-1">
                    <li>ট্রেনিং শেষে ১৩,৫০০- ১৫,০০০ টাকা ভাতা পাওয়ার সুযোগ।</li>
                    <li>প্রশিক্ষণ শেষে উত্তীর্ণ প্রশিক্ষণার্থদের ASSET প্রকল্প থেকে সাটিফিকেট প্রদান করা হবে।</li>
                    <li>প্রশিক্ষণ শেষে চাকরি পেতে সহায়তা করা হবে।</li>
                  </ol>


              <div className="heading mt-3">দায়বদ্ধতাঃ</div>
                  <ol className="mt-1">
                    <li>প্রশিক্ষণার্থীদের প্রতিটি ক্লাসে উপস্থিত থাকতে হবে।</li>
                    <li>প্রশিক্ষণার্থীদের পরীক্ষায় উপস্থিত থাকতে হবে।</li>
                    <li>প্রশিক্ষণার্থীদের পরীক্ষায় উত্তীর্ণ হওয়ার সর্বোচ্চ চেষ্টা করতে হবে।</li>
                  </ol>

                    <div className="heading mt-3">ভর্তির জন্য যা প্রয়োজনঃ</div>
                  <ol className="mt-1">
                    <li>২ কপি পাসপোর্ট সাইজের ছবি।</li>
                    <li>জাতীয় পরিচয় পত্র।</li>
                    <li><strong>এইচ.এস.সি</strong> বা সমমান পাশের সনদের ফটোকপি।</li>
                    <li>আবেদনকারীর বয়স ১৮-৪০ হতে হবে।</li>
                  </ol>

                {/* <NavLink
                  className="btn"
                  exact
                  target="_blank"
                  to="https://docs.google.com/forms/d/e/1FAIpQLSf2MVdesUIRnhAQ1FfSjj_-Ckurh4K1ZZNc5B1b6CIDdK8JQw/viewform?usp=dialog"
                >
                  রেজিস্ট্রেশন
                </NavLink> */}
              </div>
              </div>

              <div className="form-container">
                {/* <h4 className="h4-form">
                  <strong>রেজিস্ট্রেশন করতে নিচের ফর্মটি পূরণ করুন</strong>
                </h4> */}
                <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSf2MVdesUIRnhAQ1FfSjj_-Ckurh4K1ZZNc5B1b6CIDdK8JQw/viewform"
        title="Training Page"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        allowFullScreen
      ></iframe>
              </div>
              
            </div>
          </Col>
          {/* <Col md={12} className="hoverer">
            <div className="full-container">
              <div className="img-container">
                <img src={digital} alt="courses" />
              </div>
              <div className="details-holder">
                <div className="heading">কোর্সের নাম</div>
                <div>ডিজিটাল মার্কেটিং ফর ফ্রিল্যান্সিং (লেভেল-৩)</div>
                <div className="heading mt-3">
                  সুযোগ সুবিধা ও ভর্তির শর্তসমূহ
                </div>
                <ul>
                  <li>দক্ষ ও অভিজ্ঞ প্রশিক্ষক দ্বারা প্রশিক্ষণ প্রদান</li>
                  <li>প্রশিক্ষণার্থীদের প্রশিক্ষণ শেষে ভাতা প্রদান করা হবে</li>
                  <li>ক্লাসে অবশ্যই উপস্থিত থাকতে হবে</li>
                  <li>
                    আবশ্যিক ভাবে NSDA এর আওতায় লেভেল-৩ এসেসমেন্ট এ অংশগ্রহণ করতে
                    হবে
                  </li>
                  <li>
                    প্রশিক্ষণ শেষে উত্তীর্ণ শিক্ষার্থীদের এর সরকারী সনদপত্র
                    প্রদান করা হবে
                  </li>
                  <li>
                    কোর্স শেষে উত্তীর্ণ প্রশিক্ষণার্থীদের দক্ষতা প্রমাণে দেশ ও
                    বিদেশে কর্মসংস্থানের জন্য বিশেষ সহায়তা প্রদান করা হবে
                  </li>
                </ul>
                <div className="heading">ক্লাস শুরু : ১৫/১১/২০২৫</div>
                <div className="heading mt-3">ভর্তির যোগ্যতা</div>
                <ul>
                  <li>নূন্যতম এইচ.এস.সি পাস</li>
                  <li>বয়স সর্বনিম্ন ১৮ হইতে সর্বোচ্চ ৪০ (পুরুষ ও মহিলা)</li>
                </ul>
                <div className="heading">যোগাযোগ</div>
                <div className="connect">
                  <span>০১৭৫১৫৯৭৬৪১</span>
                  <span>ইএটিএল (EATL)</span>
                  <span>
                    রূপায়ন শপিং স্কয়ার, লেভেল-৫, বসুন্ধরা (আবাসিক), ঢাকা
                  </span>
                </div>
                <NavLink
                  className="btn"
                  exact
                  target="_blank"
                  to="https://docs.google.com/forms/d/e/1FAIpQLSf2MVdesUIRnhAQ1FfSjj_-Ckurh4K1ZZNc5B1b6CIDdK8JQw/viewform?usp=dialog"
                >
                  রেজিস্ট্রেশন
                </NavLink>
              </div>
            </div>

          </Col> */}

       
        </Row>
      </Container>
    </Common>
  );
};
export default Training;
